import { Component } from '@angular/core';
import { Network } from '@ionic-native/network';
//import { IonicPage, NavController, NavParams,LoadingController, Loading} from 'ionic-angular';

import { NavController,LoadingController, Loading,Events } from 'ionic-angular';
 import { AuthService } from '../../providers/auth';
// import { TabsPage } from '../../pages/tabs/tabs';
// import { SigupPage } from '../../pages/sigup/sigup';
import { HomePage } from '../../pages/home/home';
// import { VerifyemailPage} from '../../pages/verifyemail/verifyemail';


// import { MobilevarificationPage } from '../../pages/mobilevarification/mobilevarification';
//import { Http , RequestOptions , Headers} from '@angular/http';
/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
 loading: Loading;
 obj:any;
 //  //tab:Tabs;

login={"Username":'',"password":'',"company_id":''};


constructor(public loadingCtrl: LoadingController,public navCtrl: NavController,public authService:AuthService,private network: Network,public events: Events) {



}

  // movetohomepage(){
  //   this.navCtrl.setRoot(HomePage);
  // }

    movetohomepage(){
     // this.navCtrl.push(TabsPage);
     //alert(this.network.type);
if(this.network.type!='none'){
  
      this.login.Username = this.login.Username;
      this.login.password = this.login.password;
      this.login.company_id = this.login.company_id;
      

      let data_parameters= this.login;
      let method='driverlogin.php';
      let temp={};
      this.loading = this.loadingCtrl.create({
       content: '',
      });
  
        this.loading.present();
     //  console.log(data_parameters);
       this.authService.postData(data_parameters,method).then((result) => {
     
       this.obj = result;
       console.log(this.obj);
       
      if(this.obj.status=='true'){
        this.loading.dismissAll();
        localStorage.setItem("car_number",this.obj.car_number);
      
        localStorage.setItem("name",this.obj.name);
        localStorage.setItem("driver_id",this.obj.driver_id);
        localStorage.setItem("company_id",this.obj.company_id);
        localStorage.setItem("profile_pic",this.obj.profile_pic);
        //localStorage.setItem("leerauftrag",this.obj.leerauftrag);
       // let fahrer = localStorage.getItem('driver_id');
      console.log(this.obj.profile_pic);
  this.events.publish("userloggedin",this.obj);
      this.navCtrl.setRoot(HomePage);
       }
      
      else{
        this.loading.dismiss();
       alert(this.obj.message);
       }
       
       }, (err) => {
         // Error log
     });

}else{
  alert('Bitte prüfen Sie Ihre Internet-Verbindung');
}
   }


  //  signuppagemove(){
  //  this.navCtrl.push(SigupPage);
  //  }

  //  mobilvaripagemove(){
  //  this.navCtrl.push(MobilevarificationPage);
  //  }

  


    
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts